// extracted by mini-css-extract-plugin
export default {"relations":"ProductRelations_relations__r9266","columns":"ProductRelations_columns__GrubG","relation":"ProductRelations_relation__ZDjzG","metric":"ProductRelations_metric__QPSWK"};